import Validator from '@shared/validatorjs/src/validator';
import { UpdateField, SetDefaultData, CreateContactTitleRequest } from '../contact-titles.actions';
import { getCreateContactTitleState } from '../contact-titles.selectors';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Map } from 'immutable';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-create-contact-title',
  templateUrl: './create-contact-title.component.html',
  styleUrls: ['./create-contact-title.component.css']
})
export class CreateContactTitleComponent extends FormTrait implements OnInit, OnDestroy {

  public isLoading: boolean;
  private state$: Subscription;
  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createContactTitle'))

    this.state$ = this.store.pipe(select(getCreateContactTitleState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'createContactTitle.data')
    );
    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'createContactTitle')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required",
    };
    const validator = new Validator(
      {
        name: data.get('name'),
      },
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new CreateContactTitleRequest(payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'createContactTitle')
      );
    }
  }

}
